import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './TechnologyStack.css';

const TechnologyStack = () => {
  const [openItem, setOpenItem] = useState(null);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-20% 0px -20% 0px' });

  const technologyData = [
    {
      id: 'voice-capture',
      title: 'Voice Capture',
      description: 'Multi-Mic array with noise reduction.'
    },
    {
      id: 'speech-recognition',
      title: 'Speech Recognition',
      description: 'Advanced algorithms for accurate speech-to-text conversion.'
    },
    {
      id: 'language-translation',
      title: 'Language Translation',
      description: 'Real-time translation for multilingual communication.'
    },
    {
      id: 'edge-ai',
      title: 'Edge AI',
      description: 'On-device AI processing for enhanced speed and privacy.'
    },
    {
      id: 'data-sync-security',
      title: 'Data Sync & Security',
      description: 'Secure and seamless data synchronization with robust encryption.'
    },
  ];

  const toggleItem = (id) => {
    setOpenItem(openItem === id ? null : id);
  };

  return (
    <motion.section
      className="technology-stack-section"
      ref={ref}
      initial={{ opacity: 0, y: 60 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.7, type: 'spring', bounce: 0.35 }}
    >
      <div className="technology-stack-container">
        <div className="technology-stack-left">
          <img src="/images/Technology.png" alt="Technology Stack" className="technology-stack-image" />
          <div className="technology-stack-content">
            <h2>Technology Stack</h2>
            <a href="#" className="technology-stack-button">
              Try Genix Pendant <span className="arrow">↗</span>
            </a>
          </div>
        </div>
        <div className="technology-stack-right">
          {technologyData.map((item) => (
            <div key={item.id} className="accordion-item">
              <div className="accordion-header" onClick={() => toggleItem(item.id)}>
                <h3>{item.title}</h3>
                <span className="accordion-icon">
                  {openItem === item.id ? '×' : '+'}
                </span>
              </div>
              {openItem === item.id && (
                <div className="accordion-content">
                  <p>{item.description}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default TechnologyStack; 